module.exports = __webpack_public_path__ + "static/img/banner6.239802d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner6.png
// module id = rO5K
// module chunks = 52